import { storageService } from "./storage.service";

export type ConsentValue = "accepted" | "rejected";

const CONSENT_KEY = "cookie_consent";
const GTM_ID = "GTM-KLGWN43";

let gtmLoaded = false;

function getConsent(): ConsentValue | null {
    return storageService.load<ConsentValue | null>(CONSENT_KEY, null);
}

function setConsent(value: ConsentValue): void {
    storageService.store(CONSENT_KEY, value);
    if (value === "accepted") {
        loadGtm();
    }
}

function hasDecision(): boolean {
    return getConsent() !== null;
}

/**
 * Injects Google Tag Manager. Called only after the user accepts cookies
 * (or on load when consent was previously granted). Safe to call multiple
 * times - it will only inject once per page load.
 */
function loadGtm(): void {
    if (gtmLoaded || typeof window === "undefined") return;
    gtmLoaded = true;

    const w = window as any;
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.appendChild(script);

    const noscript = document.createElement("noscript");
    const iframe = document.createElement("iframe");
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    noscript.appendChild(iframe);
    document.body.appendChild(noscript);
}

/**
 * Loads tracking on app boot if the user has already accepted.
 */
function initConsent(): void {
    if (getConsent() === "accepted") {
        loadGtm();
    }
}

export const consentService = {
    getConsent,
    setConsent,
    hasDecision,
    initConsent,
    loadGtm,
};
